import {} from 'react';
import { LineChart, Line, ResponsiveContainer, Text } from 'recharts';

import {
  MetricGridContainerStyledComponent,
  MetricGraphBoxContainerStyledComponent,
  MetricGridStyledComponent,
  MetricBoxContainerStyledComponent,
  MetricCountTypograpgyStyledComponent,
  MetricLabelTypograpgyStyledComponent,
} from '../MetricStyledComponents';
import {
  metricTypeEnum,
  renderComponentEnum,
} from 'app/pages/SalesPortalPage/LayoutV1/data/type';
import { mockGraphData } from 'app/pages/SalesPortalPage/LayoutV1/data/salesDemoMockData';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type MetricComponentProps = {
  metric;
  onClickMetrics;
  selectedMetric;
  metricColor;
  index: number;
  metricsLength: number;
  selectedBox: number;
  setSelectedBox;
};

export const MetricComponent = ({
  metric,
  onClickMetrics,
  selectedMetric,
  metricColor,
  index,
  metricsLength,
  selectedBox,
  setSelectedBox,
}: MetricComponentProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <MetricGridContainerStyledComponent
        container
        spacing={0}
        onClick={event => {
          metric?.type === metricTypeEnum.opportunityAddedInNurturing ||
          metric?.type === metricTypeEnum.segment ||
          metric?.type === metricTypeEnum.leadContacted ||
          metric?.type === metricTypeEnum.leadSold
            ? onClickMetrics(renderComponentEnum.dataGrid, {
                metricType: metric.type || '',
                metricName: metric.metric_name || '',
              })
            : null
          if(metric?.type === metricTypeEnum.opportunityAddedInNurturing ||
            metric?.type === metricTypeEnum.segment ||
            metric?.type === metricTypeEnum.leadContacted ||
            metric?.type === metricTypeEnum.leadSold)
              setSelectedBox(index)
        }}
        showPointer={
          metric?.type === metricTypeEnum.opportunityAddedInNurturing ||
          metric?.type === metricTypeEnum.segment ||
          metric?.type === metricTypeEnum.leadContacted ||
          metric?.type === metricTypeEnum.leadSold
            ? true
            : false
        }
        active={selectedBox === index ? true : false}
      >
        {/* Main Metric */}
        <MetricGridStyledComponent
          item
          xs={12}
          sm={12}
          isSelected={metric?.type === selectedMetric ? true : false}
        >
          <MetricBoxContainerStyledComponent>
            <MetricCountTypograpgyStyledComponent variant={'h2'}>
              {metric?.count}
            </MetricCountTypograpgyStyledComponent>
          </MetricBoxContainerStyledComponent>
          <MetricLabelTypograpgyStyledComponent variant={'h5'}>
            {metric?.metric_name}
          </MetricLabelTypograpgyStyledComponent>
        </MetricGridStyledComponent>
      </MetricGridContainerStyledComponent>
    </Box>
  );
};
